import * as React from 'react';

import {MerieSchema} from 'src/js/common/types';
import {TemplatedCellRendererParams} from 'src/js/containers/grid';

type Props = TemplatedCellRendererParams<
  MerieSchema.components['schemas']['EvaluatedEncounterDto']['riskScoreValue']
>;

export const RiskScoreFormatter: React.FC<Props> = (props) => {
  const {value} = props;

  return value ? <div title={value}>{value}</div> : null;
};

RiskScoreFormatter.displayName = 'RiskScoreFormatter';
